/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Banner action kind enumeration.
 */
export type BannerActionKind = typeof BannerActionKind[keyof typeof BannerActionKind];


export const BannerActionKind = {
  user_profile: 'user_profile',
  shelf: 'shelf',
  categories: 'categories',
  paywall: 'paywall',
  book: 'book',
  collection: 'collection',
  category: 'category',
} as const;
